import axios from "axios";

import { Listing, Service } from "../types";
import serialiseService from "./serialiseService";

async function searchById(id: string): Promise<Listing> {
  const response = await axios
    .get<Service>(`/nhsd/service/${id}`)
    .then((response) => {
      return serialiseService(response.data);
    });

  return response;
}

export default searchById;
